import { ArdoqId } from '@ardoq/api-types';
import { Observable, combineLatest, map } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  assetFolders$,
  AssetFoldersState,
} from 'streams/assetFolders/assetFolders$';
import { openedViewpointData$ } from './openedViewpointData$';

const toFolderId = (
  folders: AssetFoldersState,
  viewpointId: ArdoqId | null
): ArdoqId | null => {
  if (!viewpointId) {
    return null;
  }
  const folder = folders.find(({ content }) =>
    content.some(({ _id }) => _id === viewpointId)
  );
  return folder?._id ?? null;
};

export const openedViewpointFolderId$: Observable<ArdoqId | null> =
  combineLatest([
    openedViewpointData$.pipe(
      map(({ openedViewpoint }) => openedViewpoint?._id ?? null),
      distinctUntilChanged()
    ),
    assetFolders$,
  ]).pipe(
    map(([viewpointId, folders]) => toFolderId(folders, viewpointId)),
    distinctUntilChanged()
  );
